import React from 'react';
import { useUser } from '../../utils/userContext';
import { Navigate, Outlet } from 'react-router-dom';

function ProtectedRoute() {
  const { user, loading } = useUser();

//  useEffect(() => {
//    console.log('ProtectedRoute effect - User:', user?.uid, 'Loading:', loading);
//  }, [user, loading]);

//  console.log('ProtectedRoute render - User:', user, 'User Subscribed:', user?.subscribed);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user || !user.subscribed) {
    console.log('ProtectedRoute - Redirecting to login');
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}

export default ProtectedRoute;